import { CommunityMemberSkeleton } from "./CommunityMemberWithConnection/CommunityMemberSkeleton";

const DEFAULT_ITEM_COUNT = 4;

interface ListViewSkeletonProps {
  count?: number;
}

export const ListViewSkeleton = ({
  count = DEFAULT_ITEM_COUNT,
}: ListViewSkeletonProps) => (
  <div className="member-directory-members">
    <ul
      className="flex list-none flex-col gap-y-4"
      data-testid="directory_members_list_skeleton"
    >
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key -- No need to use a unique key
        <CommunityMemberSkeleton key={index} />
      ))}
    </ul>
  </div>
);
